import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { API_PATH2 } from './config';

function NewId() {
  const { id } = useParams(); // <-- esto reemplaza this.props.match.params
  const [noticia, setNoticia] = useState(null);

  useEffect(() => {
    fetch(`${API_PATH2}sala_lectura/${id}`)
      .then(r => r.json())
      .then(data => setNoticia(data));
  }, [id]);

  if (!noticia) return <div className="preloader" >
                    <div className="div-transform">
                        <div className="loader">
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                            <div className="face">
                <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>;

    function formatFecha(fechaWP) {
        return new Date(fechaWP).toLocaleDateString("pt-BR", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    }

  return (
    <div className='container'>
        <div className="breadcrumbs">
             <span>
                <label >Noticias &nbsp;<i className="fa fa-angle-right"></i>&nbsp;<Link className="aBlue" to="/comunicacao-externa"> Comunicação Externa</Link> </label>
             </span> 
        </div>
        <h1 className="content-news-h1" dangerouslySetInnerHTML={{ __html: noticia.title.rendered }} />
        <span className="fecha-n">{formatFecha(noticia.date)}</ span> <br/> <br/>
        <div
            dangerouslySetInnerHTML={{ __html: noticia.content.rendered }}
            className="text-justify font-18 content-news-content pjus"
        />
        <br/>
    </div>
  );
}

export default NewId;
